import { render, staticRenderFns } from "./MessageTemplateForm.vue?vue&type=template&id=ed1c4032&"
import script from "./MessageTemplateForm.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplateForm.vue?vue&type=style&index=0&id=ed1c4032&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports